import React from "react";
import PaymentsBar from "../../../components/paymentsBar/PaymentsBar";
import DetailsSection from "../detailsSection/DetailsSection";
import TtileSection from "../titleSection/TtileSection";

import styles from "./EventPageMobile.module.scss";

type EventPageProps = {
  title: string;
  description: string;
  image: string;
  date: string;
  venue: string;
  address: string;
  city: string;
  province: string;
  agendaLink: string;
  refundPolicy: boolean;
  transferPolicy: boolean;
  price: number;
  quantity: number;
  onContinue: () => void;
};

export default function EventPageMobile({
  title,
  description,
  image,
  date,
  venue,
  address,
  city,
  province,
  agendaLink,
  refundPolicy,
  transferPolicy,
  price,
  quantity,
  onContinue,
}: EventPageProps) {
  const EventOverviewSection = () => (
    <div className={styles.contentSection}>
      <h3 className={styles.eventSectionTitle}>Overview</h3>
      <p
        className={styles.eventPageText}
        dangerouslySetInnerHTML={{__html: description}}
      />
    </div>
  );

  const EventLocationSection = () => (
    <div className={styles.contentSection}>
      <h3 className={styles.eventSectionTitle}>Location</h3>
      <p className={styles.eventPageText}>{venue}</p>
      <p className={styles.eventPageText}>{address}</p>
    </div>
  );

  const EventAgendaSection = () => (
    <div className={`${styles.contentSection} ${styles.lastContentSection}`}>
      <h3 className={styles.eventSectionTitle}>Agenda</h3>
      <a
        className={styles.eventPageLinkText}
        href={agendaLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        View Event Agenda
      </a>
    </div>
  );

  return (
    <>
      <img className={styles.eventImage} src={image} alt="Event Page" />
      <div className={styles.contentContainer}>
        <TtileSection
          title={title}
          venue={venue}
          city={city}
          province={province}
          date={date}
        />
        <EventOverviewSection />
        <EventLocationSection />
        <DetailsSection
          refunds={refundPolicy}
          transfers={transferPolicy}
          details={"Transfer dates will be announced soon"}
        />
        <EventAgendaSection />
      </div>
      <PaymentsBar
        currency={"CAD"}
        price={price}
        available={true}
        buttonText="Tickets"
        onClick={onContinue}
      />
    </>
  );
}
